import { render } from "./Category.vue?vue&type=template&id=7080bfd0&scoped=true"
import script from "../js/category.js?vue&type=script&lang=js"
export * from "../js/category.js?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=7080bfd0&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7080bfd0"]])

export default __exports__